import {
  paramsAreEqual
} from "./chunk-VCIQNQ3T.mjs";
import {
  waitForTemplatedPathnameToBeReady
} from "./chunk-H3EDKUGZ.mjs";

// src/components/events/impression/impression.tsx
import { Impression } from "@youversion/analytics-youversion-private";
import { useEffect, useState } from "react";
import { Fragment, jsx } from "react/jsx-runtime";
function FireImpression({ contentType, children, params }) {
  const [fired, setFired] = useState(null);
  useEffect(() => {
    if (typeof window !== "undefined" && (!fired || !paramsAreEqual(params, fired))) {
      waitForTemplatedPathnameToBeReady().then((templatedPathnameIsReady) => {
        if (templatedPathnameIsReady) {
          Impression[contentType].fire(params);
        }
      });
      setFired(params);
    }
  }, [contentType, fired, params]);
  return /* @__PURE__ */ jsx(Fragment, { children });
}

export {
  FireImpression
};
